import React from "react";
import { Box, Skeleton, Grid, Paper } from "@mui/material";

export function MovementCardSkeleton() {
  return (
    <Box sx={{ mt: 2 }}>
      {[...Array(3)].map((_, i) => (
        <Paper elevation={2} sx={{ p: 2, mb: 3 }} key={i}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={8}>
              <Skeleton width="80%" height={24} />
            </Grid>
            <Grid item xs={4} sx={{ textAlign: "right" }}>
              <Skeleton width={80} height={24} />
            </Grid>
          </Grid>

          <Box sx={{ mt: 1 }}>
            <Skeleton width="60%" height={20} />
            <Skeleton width="70%" height={20} sx={{ mt: 1 }} />
            <Skeleton width="50%" height={20} sx={{ mt: 1 }} />
          </Box>

          <Skeleton
            variant="rectangular"
            height={60}
            width="100%"
            sx={{ mt: 2 }}
          />

          <Box sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}>
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} variant="rounded" width={80} height={36} />
            ))}
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
